"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _heroAttributesModule = _interopRequireDefault(require("./hero-attributes.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var HeroAttributes = function HeroAttributes(_ref) {
  var _ref$heroAttributes = _ref.heroAttributes,
    heroAttributes = _ref$heroAttributes === void 0 ? [] : _ref$heroAttributes;
  if (!(heroAttributes !== null && heroAttributes !== void 0 && heroAttributes.length)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames.default)(_heroAttributesModule.default['hero-attributes']),
    "data-testid": "hero-attributes",
    children: heroAttributes.map(function (attr) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: (0, _classnames.default)(_heroAttributesModule.default['hero-attributes__attr']),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: (0, _classnames.default)(_heroAttributesModule.default['hero-attributes__attr-title']),
          children: [attr.displayName, ":", ' ']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames.default)(_heroAttributesModule.default['hero-attributes__attr-value']),
          children: attr.values.join(",\xA0")
        })]
      }, "hero-".concat(attr.key, "}"));
    })
  });
};
HeroAttributes.propTypes = [_propTypes.default.shape({
  key: _propTypes.default.string,
  displayName: _propTypes.default.string,
  values: _propTypes.default.arrayOf(_propTypes.default.string)
})];
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(HeroAttributes);